/*
 * cordy-motion.js
 * --------------------------------------------------------------------------
 * Dezente Scroll-Reveal-Animationen für alle Cordy-Sections.
 * - Kein Framework, ~1 KB, IntersectionObserver-basiert.
 * - Kein Per-Section-Markup nötig: markiert kuratierte Cordy-Elemente selbst.
 * - prefers-reduced-motion-sicher; ohne JS bleibt alles sichtbar.
 * - Stagger: Geschwister derselben Gruppe erscheinen leicht versetzt.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  // Ohne IntersectionObserver: nichts verstecken, einfach sichtbar lassen.
  if (!('IntersectionObserver' in window)) return;

  // Aktiviert die CSS-Startzustände (opacity:0 …) erst, wenn JS läuft.
  root.classList.add('cordy-motion');

  // Bewegung respektiert Nutzerpräferenz – Elemente bleiben dann sichtbar.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Kuratierte Reveal-Ziele (unsere eigenen BEM-Klassen).
  var SELECTORS = [
    '.cordy-hero__text', '.cordy-hero__media',
    '.cordy-what__inner > *',
    '.cordy-steps__head', '.cordy-steps__item',
    '.cordy-3d__inner > *',
    '.cordy-ps__text', '.cordy-ps__media', '.cordy-ps__wall > *',
    '.cordy-ps__gcol > *',
    '.cordy-benefits__head', '.cordy-benefits__card',
    '.cordy-uc__head', '.cordy-uc__card',
    '.cordy-pt__head', '.cordy-pt__step', '.cordy-pt__cta-wrap',
    '.cordy-faq__head', '.cordy-faq__item',
    '.cordy-cta__inner > *',
    '.cordy-ptr__card'
  ];

  function init() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    var nodes = document.querySelectorAll(SELECTORS.join(','));
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-cordy-reveal')) return;
      el.setAttribute('data-cordy-reveal', '');

      // Stagger: Position unter gleichartigen Geschwistern (max. 6 Stufen).
      var i = 0, prev = el.previousElementSibling;
      while (prev && i < 6) {
        if (prev.className === el.className) i++;
        prev = prev.previousElementSibling;
      }
      if (i > 0) el.style.transitionDelay = (i * 70) + 'ms';

      io.observe(el);
    });
  }

  /*
   * Parallax: Spalten mit [data-cordy-parallax] schweben beim Scrollen
   * unterschiedlich schnell (data-speed = px-Amplitude, +/-). Der rAF-Loop
   * laeuft nur, solange die zugehoerige Sektion sichtbar ist.
   */
  function initParallax() {
    var cols = document.querySelectorAll('[data-cordy-parallax]');
    if (!cols.length) return;

    // Nach Sektion gruppieren – eine Gruppe = ein Loop.
    var groups = [];
    cols.forEach(function (col) {
      var section = col.closest('.cordy-ps') || col.parentElement;
      var group = null;
      for (var g = 0; g < groups.length; g++) {
        if (groups[g].section === section) { group = groups[g]; break; }
      }
      if (!group) {
        group = { section: section, items: [], active: false, raf: 0 };
        groups.push(group);
      }
      group.items.push({
        el: col,
        speed: parseFloat(col.getAttribute('data-speed')) || 0,
        y: 0
      });
    });

    function tick(group) {
      var rect = group.section.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      // Fortschritt: Sektionsmitte relativ zur Viewportmitte, -1…1
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      var damp = window.innerWidth < 750 ? 0.5 : 1;

      group.items.forEach(function (item) {
        var target = progress * item.speed * damp;
        // Lerp: weiches Nachziehen statt hartem Mitscrollen
        item.y += (target - item.y) * 0.1;
        item.el.style.transform = 'translate3d(0,' + item.y.toFixed(2) + 'px,0)';
      });

      if (group.active) group.raf = requestAnimationFrame(function () { tick(group); });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var group = null;
        for (var g = 0; g < groups.length; g++) {
          if (groups[g].section === entry.target) { group = groups[g]; break; }
        }
        if (!group) return;
        if (entry.isIntersecting && !group.active) {
          group.active = true;
          group.items.forEach(function (item) { item.el.style.willChange = 'transform'; });
          group.raf = requestAnimationFrame(function () { tick(group); });
        } else if (!entry.isIntersecting && group.active) {
          group.active = false;
          cancelAnimationFrame(group.raf);
          group.items.forEach(function (item) { item.el.style.willChange = ''; });
        }
      });
    }, { rootMargin: '10% 0px 10% 0px' });

    groups.forEach(function (group) { io.observe(group.section); });
  }

  function boot() {
    init();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
